export const aqua50 = "#e9fafa";
export const aqua100 = "#daf8f8";
export const aqua200 = "#b5f1f1";
export const aqua300 = "#91eaea";
export const aqua400 = "#6ce3e3";
export const aqua500 = "#48dddd";
export const aqua600 = "#3bcad6";
export const aqua700 = "#2eb9cf";
export const aqua800 = "#21a7c7";
export const aqua900 = "#1495c0";
export const aqua1000 = "#0581a6";
export const aquaA100 = "#81f8f8";
export const aquaA200 = "#6ceeee";
export const aquaA400 = "#24cccc";
export const aquaA500 = "#05b1b1";
export const aquaA1000 = "#194d4d";
